module.exports = __webpack_public_path__ + "27f62434671ea6fe88d93893d05b7202.png";